"use client";

/**
 * The way back on the marketing sites: a floating pill, so withdrawing consent
 * stays reachable from every page. The portal turns it off and draws a footer
 * row (Privacy, Cookie settings, Terms) in each layout instead.
 *
 * Hidden while the banner is up: two things asking the same question at once.
 */
import { useConsent } from "./ConsentProvider";

export function ConsentSettingsLink({ label }: { label: string }) {
  const { ready, reopen, mustAsk, panelOpen } = useConsent();
  // Same reason as the banner: waiting avoids a flash of the wrong one.
  if (!ready || mustAsk || panelOpen) return null;

  return (
    <button
      type="button"
      onClick={reopen}
      data-testid="consent-settings-link"
      className="left-4 bottom-4 px-3.5 py-2 backdrop-blur fixed z-40 cursor-pointer rounded-full border border-border bg-background/90 text-xs text-muted-foreground"
    >
      {label}
    </button>
  );
}
